import React,{useState,useEffect} from 'react'
import { Link } from 'react-router-dom'

import Navbar from '../../components/navbar'
import Footer from '../../components/footer'
import VideoModalTwo from '../../components/video-modal-two'
import Partner from '../../components/partner'
import ClientOne from '../../components/client-one'
import TopCoworkingCity from '../../components/top-coworking-city'
import PricingThree from '../../components/pricing-three'

import bg1 from '../../assets/images/cowork/bg1.jpg'
import bg2 from '../../assets/images/cowork/bg2.jpg'
import bg3 from '../../assets/images/cowork/bg3.jpg'
import about1 from '../../assets/images/marketing/01.png'

import {FiArrowRight, FiHelpCircle} from '../../assets/icons/vander'
import { coworkServices } from '../../data/data'

const images = [bg1, bg2, bg3];

export default function IndexCoworking() {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
        if(currentIndex === images.length - 1) {
            setCurrentIndex(0);
        } 
        else {
             setCurrentIndex(currentIndex + 1);
        }
    }, 5000)
    
    return () => clearInterval(intervalId);
}, [currentIndex])
  return (
    <>
    <Navbar navLight={true}/> 

    <section className="bg-half-170 d-table w-100" id="home" style={{backgroundImage:`url(${images[currentIndex]})`, backgroundSize:'cover', backgroundRepeat:'no-repeat', backgroundPosition:'center'}}>
      <div className="bg-overlay"></div>
      <div className="container">
          <div className="row mt-5 align-items-center">
              <div className="col-lg-4 col-md-6">
                  <div className="bg-white shadow-lg rounded p-4 position-relative">
                      <div className="text-center">
                          <h4 className="mb-4">Book Your Space</h4>  
                      </div>
                      <form>
                          <div className="row">
                              <div className="col-12">
                                  <div className="mb-3">
                                      <label className="form-label">Your Email <span className="text-danger">*</span></label>
                                      <input type="email" className="form-control"  name="email" required="" placeholder="Your Email :"/>
                                  </div>
                              </div>
                              <div className="col-12">
                                  <div className="mb-3">
                                      <label className="form-label"> Date : <span className="text-danger">*</span></label>
                                      <input name="date" type="text" className="form-control start" placeholder="Date"/>
                                  </div>
                              </div>
                              <div className="col-md-6 col-12">
                                  <div className="mb-3">
                                      <label className="form-label">Space size : <span className="text-danger">*</span></label>
                                      <input type="number" min="1" autoComplete="off" id="adult" required="" className="form-control" placeholder="1"/>
                                  </div>
                              </div>
                              <div className="col-md-6 col-12">
                                  <div className="mb-3">
                                      <label className="form-label">Company <span className="text-danger">*</span></label>
                                      <select className="form-control custom-select">
                                          <option value="1">Private office</option>
                                          <option value="2">Dedicated Space</option>
                                          <option value="3">Small office</option>
                                          <option value="4">Floating Seat</option>
                                          <option value="5">Startups Desk</option>
                                          <option value="6">Retail Space</option>
                                          <option value="7">Meeting Room</option>
                                      </select>
                                  </div>
                              </div>
                              <div className="col-12">
                                  <div className="mb-3">
                                      <div className="form-check">
                                          <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault"/>
                                          <label className="form-check-label" htmlFor="flexCheckDefault">I Accept <Link to="#" className="text-primary">Terms And Condition</Link></label>
                                      </div>
                                  </div>
                              </div>
                              <div className="col-12">
                                  <div className="d-grid">
                                      <button className="btn btn-primary">Reserve Now</button>
                                  </div>
                              </div>
                          </div>
                      </form>
                  </div>
              </div>
          </div>
      </div>
    </section>

    <section className="section bg-white">
      <div className="container mt-100 mt-60">
          <div className="row align-items-center">
              <div className="col-md-5 col-12">
                  <div className="positon-relative">
                      <img src={about1} className="img-fluid" alt=""/>
                      <VideoModalTwo/>
                  </div>
              </div>

              <div className="col-md-7 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">
                  <div className="section-title ms-lg-5">
                      <h4 className="title mb-4">“ Sweet as the Moment When <br/> the coworking Went 'Pop ” : <span className="fw-bold">Our Story</span></h4>
                      <p className="text-muted mb-0">This is required when, for example, the final text is not yet available. Dummy text is also known as 'fill text'. It is said that song composers of the past used dummy texts as lyrics when writing melodies in order to have a 'ready-made' text to sing with the melody.</p>
                      <div className="mt-4">
                          <Link to="/page-about" className="btn btn-primary">Learn More <FiArrowRight className="fea icon-sm"/></Link>
                      </div>
                  </div>
              </div>
          </div>
      </div>

      <div className="container mt-5 pt-2">
          <Partner/>
      </div>

      <div className="container mt-100 mt-60">
          <div className="row justify-content-center">
              <div className="col-12">
                  <div className="section-title text-center mb-4 pb-2">
                      <h4 className="title mb-4">Our Services</h4>
                      <p className="text-muted mb-0 para-desc mx-auto">Start work with Leaping. Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                  </div>
              </div>
          </div>

          <div className="row">
            {coworkServices.map((item,index)=>{
              let Icon = item.icon
              return(
                  <div className="col-lg-4 col-md-6 col-12 mt-4 pt-2" key={index}>
                      <div className="card feature border-0 bg-transparent p-4 text-center">
                          <span className="text-primary h2"><Icon className=""/></span>
                          <h5 className="mt-2">{item.title}</h5>
                          <p className="text-muted mb-0">{item.desc}</p>
                      </div>
                  </div>
              )
            })}
          </div>
      </div>

      <div className="container mt-100 mt-60">
          <div className="row align-items-end mb-lg-4 pb-lg-2">
              <div className="col-lg-5">
                  <div className="section-title mb-4 pb-2 mb-lg-0 pb-lg-0 text-center text-lg-start">
                      <h4 className="title mb-4">Top Co-working Cities</h4>
                      <p className="text-muted para-desc ms-lg-auto mx-auto mb-0">Start work with Leaping. Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                  </div>
              </div>

              <div className="col-lg-7 d-none d-lg-block">
                  <div className="text-center text-lg-end">
                      <Link to="#" className="btn btn-primary">See More <FiArrowRight className="fea icon-sm"/></Link>
                  </div>
              </div>
          </div>

          <TopCoworkingCity/>
          <div className="row justify-content-center d-lg-none d-block">
              <div className="col-12 text-center mt-4 pt-2">
                  <Link to="#" className="btn btn-primary">See More <FiArrowRight className="fea icon-sm"/></Link>
              </div>
          </div>
      </div>

      <div className="container mt-100 mt-60">
          <div className="row justify-content-center">
              <div className="col-lg-7 col-md-9 text-center">
                  <ClientOne/>
              </div>
          </div>
      </div>

      <div className="container mt-100 mt-60">
          <div className="row justify-content-center">
              <div className="col-12">
                  <div className="section-title text-center mb-4 pb-2">
                      <h4 className="title mb-4">Pricing Table</h4>
                      <p className="text-muted para-desc mx-auto mb-0">Start work with Leaping. Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                  </div>
              </div>
          </div>

          <PricingThree/>
      </div>

      <div className="container mt-100 mt-60">
          <div className="row">
              <div className="col-md-6 col-12">
                  <div className="d-flex">
                      <FiHelpCircle className="fea icon-ex-md text-primary me-2 mt-1"/>
                      <div className="flex-1">
                          <h5 className="mt-0">How our <span className="text-primary">Leaping</span> work ?</h5>
                          <p className="answer text-muted mb-0">Due to its widespread use as filler text for layouts, non-readability is of great importance: human perception is tuned to recognize certain patterns and repetitions in texts.</p>
                      </div>
                  </div>
              </div>
              
              <div className="col-md-6 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">
                  <div className="d-flex">
                    <FiHelpCircle className="fea icon-ex-md text-primary me-2 mt-1"/>
                      <div className="flex-1">
                          <h5 className="mt-0"> What is the main process open account ?</h5>
                          <p className="answer text-muted mb-0">If the distribution of letters and 'words' is random, the reader will not be distracted from making a neutral judgement on the visual impact</p>
                      </div>
                  </div>
              </div>
              
              <div className="col-md-6 col-12 mt-4 pt-2">
                  <div className="d-flex">
                      <FiHelpCircle className="fea icon-ex-md text-primary me-2 mt-1"/>
                      <div className="flex-1">
                          <h5 className="mt-0"> How to make unlimited data entry ?</h5>
                          <p className="answer text-muted mb-0">Furthermore, it is advantageous when the dummy text is relatively realistic so that the layout impression of the final publication is not compromised.</p>
                      </div>
                  </div>
              </div>
              
              <div className="col-md-6 col-12 mt-4 pt-2">
                  <div className="d-flex">
                      <FiHelpCircle className="fea icon-ex-md text-primary me-2 mt-1"/>
                      <div className="flex-1">
                          <h5 className="mt-0"> Is <span className="text-primary">Leaping</span> safer to use with my account ?</h5>
                          <p className="answer text-muted mb-0">The most well-known dummy text is the 'Lorem Ipsum', which is said to have originated in the 16th century. Lorem Ipsum is composed in a pseudo-Latin language which more or less corresponds to 'proper' Latin.</p>
                      </div>
                  </div>
              </div>
          </div>

          <div className="row mt-md-5 mt-4 pt-lg-5 pt-4 justify-content-center">
              <div className="col-12 text-center">
                  <div className="section-title">
                      <h4 className="title mb-4">Have Question ? Get in touch!</h4>
                      <p className="text-muted para-desc mx-auto">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                      <Link to="/contact" className="btn btn-primary mt-4"><i className="mdi mdi-phone"></i> Contact us</Link>
                  </div>
              </div>
          </div>
      </div>
    </section>
    <Footer/>
    </>
  )
}
